import css from 'styled-jsx/css';
import { MQ_LARGE } from 'constants/mq';

export const baseStyles = css`
  .ImageSlider {
    margin-bottom: 0.5rem;
  }

  .ImageSlider__imagesContainer {
    position: relative;
  }

  .ImageSlider__ctaOverlay {
    position: absolute;
    top: 50%;
    right: 2rem;
    transform: translateY(-50%);
  }

  .ImageSlider__ctaOverlayText {
    color: white;
    font-size: var(--fontScaleNeg1);
    letter-spacing: 0.02em;
    line-height: 1;
    text-shadow: 2px 2px 8px #000;
    text-transform: uppercase;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .ImageSlider__imageInfo {
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 0.375rem;
  }

  .ImageSlider__pinItButton--right {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    z-index: 1;
  }

  .ImageSlider__pinItButton--left {
    position: absolute;
    bottom: 1rem;
    left: 1rem;
    z-index: 1;
  }

  .ImageCaption {
    flex: 1 0 0px;
    min-width: 0;
    padding-right: 1rem;
  }

  @media ${MQ_LARGE} {
    .ImageSlider__ctaOverlayText {
      font-size: var(--baseFontSize);
    }
  }
`;

export const sliderHandleStyles = css`
  .ImageSlider__handle {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 3rem;
    width: 3rem;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 50%;
  }

  .ImageSlider__handleArrow--left {
    margin-right: 0.125rem;
  }

  .ImageSlider__handleArrow--right {
    margin-left: 0.125rem;
  }

  .ImageSlider__handleDivider {
    align-self: stretch;
    width: 3px;
    background-color: #fff;
  }
`;
